export default {
  driver_performance_driver_moduleDrivers: "Drivers",
  driver_performance_driver_title: "Driver",
  driver_performance_driver_name: "Name",
  driver_performance_driver_totalDistance: "Total Distance",
  driver_performance_driver_overview: "Overview",
  driver_performance_driver_detail_hideDescription: "Hide Description",
  driver_performance_driver_detail_showDescription: "Show Description",
  driver_performance_driver_detail_supervisorName: "Supervisor",
  driver_performance_driver_detail_riskMatrix_eventName: "Event Name",
  driver_performance_driver_detail_riskMatrix_riskScore: "Risk Score",
  driver_performance_driver_detail_riskMatrix_avgSeverity: "Avg Severity",
  driver_performance_driver_detail_riskMatrix_avgEventCount: "Avg Event Count",
  driver_performance_driver_detail_riskMatrix_driverName: "Driver Name",
  driver_performance_driver_detail_risk: "Risk",
};
